"use client";

import moment from "moment";
import Link from "next/link";

import PostCardImg from "../PostCardImg";
import Badges from "../Badges";
const styles = new Proxy({"PostCard":"PostCard-740d3","CardBody":"CardBody-740d3","Tags":"Tags-740d3","CardTitle":"CardTitle-740d3","CardExcerpt":"CardExcerpt-740d3","CardFooter":"CardFooter-740d3","AuthorDate":"AuthorDate-740d3","AuthorName":"AuthorName-740d3","Date":"Date-740d3","ReadMore":"ReadMore-740d3"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { Post } from "../types";

interface PostCardProps {
  post: Post;
  isFirst: boolean;
  className?: string;
  router?: any;
}

const PostCard = ({ post, isFirst, router }: PostCardProps) => {
  return (
    <div className="my-3 col-lg-4">
      <div className={styles.PostCard}>
        <PostCardImg
          post={{
            featuredImage: post.titleImage?.url,
            link: `/post/${post.slug}`,
          }}
          priority={isFirst}
        />

        <div className={styles.CardBody}>
          <div className={styles.Tags}>
            <Badges badges={post.tags} limit={3} />
          </div>

          <h3 className={styles.CardTitle}>
            <Link href={`/post/${post.slug}`}>
              <span
                dangerouslySetInnerHTML={{ __html: post.title }}
                suppressHydrationWarning
              />
            </Link>
          </h3>

          <p className={styles.CardExcerpt}>{post.excerpt}</p>

          <div className={styles.CardFooter}>
            <div className={styles.AuthorDate}>
              <span className={styles.AuthorName}>{post.author.name}</span>
              <span className={styles.Date}>
                {moment(post.scheduledAt ?? post.createdAt).format(
                  "DD/MM/YYYY",
                )}
              </span>
            </div>
            <Link href={`/post/${post.slug}`} className={styles.ReadMore}>
              Read more
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
